<div class="detail-container">
  <div class="heading">{{ label }}</div>
  <span
    class="link-style hover:text-blue-900 cursor-pointer"
    style="font-size: 15px"
    *ngIf="showDirectionLink"
    (click)="viewDirectionLink.emit()"
  >
    Google Directions <i class="fa fa-external-link ml-1"></i>
  </span>
</div>
